import { ResponsiveContainer, BarChart, XAxis, YAxis, Bar } from 'recharts';

import './WasteTypePeriodBlock.scss';
import { dateFormatDaily } from '../functions';

interface WasteTypePeriodBlockProps {
  graphData: any[];
  tableData: any[];
  typeArray: any[];
};

const WasteTypePeriodBlock = (props: WasteTypePeriodBlockProps) => {
  const displayedGraphData = props.graphData.map(period => {
    return {
      ...period,
      name: dateFormatDaily(period.name)
    };
  });
  const printableTableData = props.tableData.map(wt => {
    const convertedName = dateFormatDaily(wt[0]);
    return [convertedName, wt[1], wt[2]];
  });
  const periodHeaders = displayedGraphData.map(period => period.name);
  const displayedTableData = props.typeArray.map(type => {
    const wasteTypeValues = printableTableData.filter(wt => wt[1] === type.label);
    const valueArr = periodHeaders.map(header => {
      const wt = wasteTypeValues.find(wt => wt[0] === header);
      return wt ? wt[2] : 0;
    });
    return [
      type.color,
      type.label,
      ...valueArr
    ];
  });
  return (
    <div className='split-container-period'>
      <div className='graph'>
        <ResponsiveContainer width='100%' height={480}>
          <BarChart height={480} data={displayedGraphData} margin={{ right: 40 }}>
            <XAxis dataKey="name" />
            <YAxis minTickGap={10} />
            {props.typeArray.map((type, idx) =>
              <Bar key={'wt-period-block-' + idx} dataKey={type.label} stackId='a' fill={type.color} />
            )}
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className='table'>
        <table>
          <tr>
            <th style={{ width: '1%', backgroundColor: 'transparent', border: 'transparent' }}></th>
            <th style={{ width: '32%' }}>Waste Type</th>
            {periodHeaders.map((header, idx) =>
              <th key={'wt-period-header-' + idx} style={{ width: (67 / (periodHeaders.length + 1)) + '%' }}>{header}</th>
            )}
          </tr>
          {displayedTableData.map((wt, idx) =>
            <tr key={'wt-period-export-' + idx}>
              <td style={{ width: '1%', border: 'transparent' }}>
                <div className='color-circle' style={{ backgroundColor: wt[0] }}></div>
              </td>
              <td style={{ width: '32%' }}>{wt[1]}</td>
              {periodHeaders.map((_, idx) =>
                <td key={'wt-period-content-' + idx} style={{ width: (67 / (periodHeaders.length + 1)) + '%' }}>{wt[idx + 2]}</td>
              )}
            </tr>
          )}
        </table>
      </div>
    </div>
  );
};

export default WasteTypePeriodBlock;